import { characteristics } from '../data/characteristics';
import { harmonicLevels } from '../data/harmonicLevels';
import type { Score } from '../types';
import type { HarmonicScore } from '../types/harmonic';

export function formatCharacteristicScores(scores: Score[]): string {
  return scores
    .map(score => {
      const char = characteristics.find(c => c.id === score.characteristicId);
      return `${char?.name || score.characteristicId}: ${Math.round(score.normalized)}%`;
    })
    .join('\n');
}

export function formatHarmonicScores(harmonicScores: HarmonicScore[]): string {
  const sorted = [...harmonicScores].sort((a, b) => b.normalized - a.normalized);
  return sorted
    .map(score => {
      const level = harmonicLevels.find(l => l.id === score.levelId);
      return `${level?.name || `Level ${score.levelId}`}: ${Math.round(score.normalized)}%`;
    })
    .join('\n');
}

export function getDominantHarmonic(harmonicScores: HarmonicScore[]): string {
  if (harmonicScores.length === 0) return 'Unknown';
  const dominant = harmonicScores.reduce((prev, current) =>
    current.normalized > prev.normalized ? current : prev
  );
  const level = harmonicLevels.find(l => l.id === dominant.levelId);
  return `${level?.name || `Level ${dominant.levelId}`} (${Math.round(dominant.normalized)}%)`;
}

export function buildAssessmentContext(
  scores: Score[],
  harmonicScores: HarmonicScore[],
  respondentName: string
): string {
  return `Respondent: ${respondentName}

Characteristic Scores:
${formatCharacteristicScores(scores)}

Dominant Harmonic Level: ${getDominantHarmonic(harmonicScores)}

Harmonic Scale Scores:
${formatHarmonicScores(harmonicScores)}`;
}
